import { c as _c } from "react/compiler-runtime";
import { TextField } from "@flat-ui";
import { AnalyticsFeedbackStepLayout } from "@components/analytics/in-house/feedback/analytics-feedback-step";
/** Free-text "one thing that would help you most" step. */
function AnalyticsFeedbackStep2Content(t0) {
  const $ = _c(5);
  const {
    answers,
    onAnswersChange
  } = t0;
  let t1;
  if ($[0] !== onAnswersChange) {
    t1 = oneThing => onAnswersChange({
      oneThing
    });
    $[0] = onAnswersChange;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== answers.oneThing || $[3] !== t1) {
    t2 = <AnalyticsFeedbackStepLayout title="If we could make one improvement first, what would help you most?" subtext={"We want analytics to do more for you. Tell us the single most valuable thing we could add or improve \u2014 and we'll start there."}><TextField multiline={true} minRows={4} fullWidth={true} placeholder={"The one thing that would help you most\u2026"} text={answers.oneThing} onTextChanged={t1} /></AnalyticsFeedbackStepLayout>;
    $[2] = answers.oneThing;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}

/** Step definition registered in the survey flow. */
export const analyticsFeedbackStep2 = {
  stepName: "oneThing",
  StepComponent: AnalyticsFeedbackStep2Content,
  isValid: () => true
};